import { IApplicationState } from '../../types/redux';

export const selectCounterText = (state: IApplicationState): string | null => {
  return state.totalCount;
};
